<template>
	<div class='course-content'>
		<div class='course-top overflow'>
			<div class="course-title">参赛{{region_theme_text}}</div>
			<button class="back-btn" type="button" @click="edit">
				<span><img src="../assets/img/no-edit.png"></span>
				<span>返回</span>
			</button>
		</div>
		<div class="search-top overflow">
				<div class="checkbox-div">
					<span>视频：</span>
						<el-checkbox-group
							v-model="videoStatusArr"
							@change="onVideoStatusChange"
							style="margin-right: 10px;"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group>
						<!-- <span style="margin-right: 8px;">音频：</span>
						<el-checkbox-group
							v-model="audioStatusArr"
							@change="onAudioStatusChange"
							style="margin-right: 10px;"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group> -->
						<span>附件：</span>
						<el-checkbox-group
							v-model="fileStatusArr"
							@change="onFileStatusChange"
						>
							<el-checkbox-button :label="1">有</el-checkbox-button>
							<el-checkbox-button :label="0">无</el-checkbox-button>
						</el-checkbox-group>
				</div>
				<el-input :placeholder="'输入编码/' + util.getKeyFrontValue('name') + '/所属单位进行搜索'"  class="search-input" v-model="search"></el-input>
				<button class="search-btn" type="button" @click="searchList"><i class="el-icon-search"></i>搜索</button>
				<button class="reset-btn" type="button" @click="reset">重置</button>
			</div>
		<div class="filter-status-box">
			状态：
			<el-select v-model="nav" @change="navChange" clearable>
				<el-option label="待通过" value="filtering"></el-option>
				<el-option label="已通过" value="filtered"></el-option>
			</el-select>
		</div>
		<div>
			<div class="table-content">
				<el-table :data="tabList" v-loading="loading" border stripe :header-cell-style="{background: '#EEF7FE',color:'black'}">
					<el-table-column prop="id" label="编码" align="center" width="123"></el-table-column>
					<el-table-column :label="util.getKeyFrontValue('cover')" width="120" align="center">
						<template slot-scope="scope">
							<el-popover placement="right" title="" trigger="hover" width="250" style="cursor: pointer;">
								<el-image slot="reference" :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"
									style="height: 75px;width:60px"></el-image>
								<el-image :src="alOssUrl+scope.row.cover+util.imgSize.imgQ40"></el-image>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="name" :label="util.getKeyFrontValue('name')" align="center" min-width="250">
						<template slot-scope="scope">
							<div>
								<div class="row-name">{{ scope.row.name }}</div>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'labor'" class="labor-label comment-margin-right-5">劳动教育</span>
								<span v-if="scope.row.o_course_category && scope.row.o_course_category.kind == 'comprehensive'" class="comprehensive-label comment-margin-right-5">综合实践</span>
								<span class="stage-label">
									{{ util.setStage(scope.row.m_competition_course_to_apply) }}
								</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="o_competition_course_author.affiliation" label="所属单位" align="center" width="200">
						<template slot-scope="scope">
							<div>
								{{scope.row.o_competition_course_author ? scope.row.o_competition_course_author.affiliation : ''}}
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="vote_count" label="点赞数" align="center" width="100">
						<template slot-scope="scope">
							{{ scope.row.vote_count ? scope.row.vote_count : 0 }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="150" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" style="color: #44D89E;" @click='detail_click(scope.row)'>详情</el-button>
							<el-button v-if="scope.row.is_current_filter" type="text" @click='upgradeCourse(scope.row)' style="color: #52a5f8;">通过</el-button>
							<el-button v-if="scope.row.is_complete_filter && scope.row.competition_course_status != util.case_course_status['on'].code" type="text" @click='rollbackCourse(scope.row)' style="color: #FF4E00;">撤销</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="block">
				<el-pagination v-if='tabList.length > 0' background @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total" :current-page="currentPage">
				</el-pagination>
			</div>
		</div>
		<courseDetail ref="courseDetail" role="filter"></courseDetail>
	</div>
</template>

<script>
	import courseDetail from '../components/courseDetail.vue'
	export default {
		name: 'index',
		components: {
			courseDetail
		},
		data() {
			return {
				region_theme_text: JSON.parse(sessionStorage.getItem('region_theme_text')) ? JSON.parse(sessionStorage.getItem('region_theme_text')) : '课程',
				level: JSON.parse(sessionStorage.getItem('userInfo')) ? JSON.parse(sessionStorage.getItem('userInfo')).level : '',
				tabList: [],
				pageSize: 5,
				total: 0,
				currentPage: 1,
				search: '',
				videoStatusArr: [],
				audioStatusArr: [],
				fileStatusArr: [],
				loading: false,
				nav: ''
			}
		},
		methods: {
			// 详情
			detail_click(row) {
				this.$refs.courseDetail.show(row)
			},
			// 筛查通过
			upgradeCourse(row) {
				this.$confirm('该课程是否通过筛查？','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.HttpUtil.Post(this.api.expert.competitionCourseNextFilter, {
						level: row.level,
					}, {
						id: row.id
					}).then(res => {
						this.$message.success('已通过！')
						this.getList()
					})
				}).catch(() => {
					
				})
			},
			onVideoStatusChange(val) {
				if (val.length > 0) {
					this.videoStatusArr = [val[val.length - 1]]
				} else {
					this.videoStatusArr = []
				}
			},
			onAudioStatusChange(val) {
				if (val.length > 0) {
					this.audioStatusArr = [val[val.length - 1]]
				} else {
					this.audioStatusArr = []
				}
			},
			onFileStatusChange(val) {
				if (val.length > 0) {
					this.fileStatusArr = [val[val.length - 1]]
				} else {
					this.fileStatusArr = []
				}
			},
			// 撤销
			rollbackCourse(row) {
				this.$confirm('是否撤销？','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.HttpUtil.Post(this.api.expert.competitionCourseRollbackFilter, {}, {
						id: row.id
					}).then(res => {
						this.$message.success('已撤销！')
						this.getList()
					})
				}).catch(() => {
					
				})
			},
			//返回
			edit() {
				this.$router.push({
					name: 'index'
				})
			},
			//分页
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			// 搜索
			searchList() {
				this.currentPage = 1
				this.getList()
			},
			// 重置
			reset() {
				this.search = ''
				this.videoStatusArr = []
				this.audioStatusArr = []
				this.fileStatusArr = []
				this.currentPage = 1
				this.getList()
			},
			getList() {
				this.loading = true
				this.HttpUtil.Get(this.api.expert.competitionCourseList, {
					page: this.currentPage,
					limit: this.pageSize,
					competition_course_poster_id: sessionStorage.getItem('competition_course_poster_id'),
					sf3: this.search,
					sq1: this.videoStatusArr.includes(1) ? 1 : null,
					sq2: this.videoStatusArr.includes(0) ? 1 : null,
					sq3: this.fileStatusArr.includes(1) ? 1 : null,
					sq4: this.fileStatusArr.includes(0) ? 1 : null,
					sq5: this.audioStatusArr.includes(1) ? 1 : null,
					sq6: this.audioStatusArr.includes(0) ? 1 : null,
					target: 'filter_plan',
					nav: this.nav || null
				}).then((res) => {
					this.tabList = res.list
					this.tabList.forEach(item => {
						this.$set(item, 'is_current_filter', 0)
						this.$set(item, 'is_complete_filter', 0)
						item.m_competition_course_to_competition_course_filter_plan.forEach(filter_plan => {
							if (filter_plan.is_current_filter == 1 && filter_plan.is_complete_filter == 0) {
								this.$set(item, 'is_current_filter', 1)
								if (item.level == null) {
									this.$set(item, 'level', filter_plan.level)
								} else {
									this.$set(item, 'level', filter_plan.level < item.level ? filter_plan.level : item.level)
								}
							}
							if (filter_plan.is_complete_filter == 1) {
								this.$set(item, 'is_complete_filter', 1)
							}
						})
					})
					this.loading = false
					this.total = res.total
				})
			},
			navChange(val) {
				this.nav = val
				this.getList()
			},
		},
		mounted() {
			this.getList()
		},
		watch: {

		}
	}
</script>

<style scoped="scoped">
	.course-content {
		width: 68%;
		min-width: 1100px;
		height: 79vh;
		margin: 0 auto;
		background-color: white;
		padding: 20px 10px 20px 25px;
		box-sizing: border-box;
		overflow-y: scroll;
		box-shadow: 0 0 100px rgba(31, 180, 249, 0.26);
	}

	.course-top {
		/* height: 40px; */
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		/* align-items: center; */
	}
	.search-top .el-checkbox-group {
		display: inline;
		margin-right: 20px;
		font-size: 14px;
	}
	.search-top {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 10px;

	}
	.filter-status-box {
		margin-bottom: 20px;
	}
	.course-title {
		font-size: 20px;
		font-weight: bold;
		color: #333333;
		letter-spacing: 1px;
		margin-bottom: 15px;
		flex-shrink: 0;
	}

	.el-table td,
	.el-table th {
		padding: 8px 0 !important;
	}

	.table-content {
		/* min-height: 49vh;
		max-height: 48vh; */
		min-height: 49vh;
		overflow-y: scroll;
	}

	.table-content /deep/ .el-table td {
		padding: 6px 0 !important
	}

	.table-content /deep/ .el-table th {
		padding: 6px 0 !important
	}

	/* 分页 */
	.block {
		text-align: center;
		margin-top: 20px;
	}
	/*表格hover*/
	/deep/.el-tag {
		border-radius: 0;
		background: none;
		border: none;
		color: black;
		font-size: 14px;
		/*line-height: 60px;*/
	}
	
	.search-input {
		width: 300px;
		height: 40px;
		margin-right: 20px;
	}
	.search-input /deep/ .el-input__inner {
		height: 40px;
		line-height: 38px;
	}
	.search-btn {
		width: 80px;
		height: 40px;
		background: #FF3B3D;
		box-shadow: 0px 3px 6px rgba(255, 59, 61, 0.16);
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		color: #ffffff;
		border: none;
		margin-right: 20px;
		cursor: pointer;
	}
	.search-btn:hover {
		background: #C6191F;
	}
	.search-btn i {
		margin-right: 5px;
	}
	.reset-btn {
		box-sizing: border-box;
		width: 80px;
		height: 40px;
		/* background: rgba(255, 255, 255, 0.39); */
		background: #E8E8E8;
		/* box-shadow: 0px 3px 6px #FF3B3D; */
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		/* color: #FF3B3D; */
		color: #333333;
		border: none;
		/* border: 1px solid #FF3B3D; */
		cursor: pointer;
		margin-right: 40px;
	}
	.reset-btn:hover {
		background: #D1D1D1;
	}
	.back-btn {
		box-sizing: border-box;
		/* width: 80px; */
		padding: 0 20px;
		height: 40px;
		line-height: 40px;
		background: #E8E8E8;
		/* box-shadow: 0px 3px 5px 0px rgba(255,59,61,0.1500), 0px -5px 5px 0px rgba(255,59,61,0.0500); */
		opacity: 1;
		border-radius: 5px;
		font-size: 16px;
		color: #333333;
		border: none;
		cursor: pointer;
	}
	.back-btn:hover {
		background: #D1D1D1;
	}
	.back-btn img {
		margin-right: 10px;
		width: 13px;
		height: 13px;
		margin-top: 2px;
	}
	.icon-style {
		color: #ffffff;
		background-color: #999999 !important;
		border-radius: 50%;
		margin-left: 1px;
	}
	.el-checkbox {
		margin-right: 0;
	}
</style>
